// extracted by mini-css-extract-plugin
export default {"textContent":"staticMhText_theme_textContent__YkrxW","gridItem":"staticMhText_theme_gridItem__IOIXF"};